import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  AlertOutlined,
  ClockCircleOutlined,
  InfoCircleOutlined,
  ExclamationCircleOutlined,
  CheckCircleOutlined,
  BellOutlined,
} from '@ant-design/icons';
import { Tooltip } from 'antd';

const NeedsAttentionCard = ({ items, loading = false }) => {
  const navigate = useNavigate();

  const handleAlertClick = (alert) => {
    // Navigation disabled as per user request
    // if (alert.action_link) {
    //   navigate(alert.action_link);
    // }
  };

  const getAlertIcon = (type, severity) => {
    switch (type) {
      case 'broadcast_stopped':
      case 'template_rejected':
      case 'subscription_expired':
        return <AlertOutlined className="text-[#F96056]" />;
      case 'sequence_ending_soon':
      case 'urgent_message':
        return <ClockCircleOutlined className="text-[#F6A723]" />;
      case 'template_pending':
        return <ExclamationCircleOutlined className="text-[#0B82F1]" />;
      default:
        return severity === 'high' ? (
          <AlertOutlined className="text-[#F96056]" />
        ) : (
          <BellOutlined className="text-[#F6A723]" />
        );
    }
  };

  return (
    <div className="col-span-12 lg:col-span-7 bg-[var(--surface)] rounded-2xl p-6 shadow-[0px_20px_50px_-32px_rgba(15,23,42,0.35)] border border-[var(--surface-border)] flex flex-col">
      <div className="flex items-center justify-between mb-6">
        <div>
          <div className="flex items-center gap-2">
            <p className="text-[18px] font-semibold text-[var(--textBlack)]">
              Needs attention
            </p>
            <Tooltip
              title="Critical items that require your immediate action"
              placement="top"
            >
              <InfoCircleOutlined className="text-[var(--font-600)] text-xs cursor-help" />
            </Tooltip>
          </div>
          {/* <p className="text-sm text-[var(--font-600)]">
            Priority issues that need action
          </p> */}
        </div>
        {items.length > 0 && (
          <span className="bg-[var(--accent-soft)] text-[var(--accent-2)] text-xs font-semibold px-2.5 py-1 rounded-full">
            {items.length} {items.length === 1 ? 'item' : 'items'}
          </span>
        )}
      </div>

      <div
        className="flex-1 overflow-y-auto listScroll pr-2 -mr-2 flex flex-col gap-3"
        style={{ maxHeight: '300px' }}
      >
        {loading ? (
          <div className="space-y-3">
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="border border-[#F3F4F6] rounded-lg px-3 py-3 flex items-start gap-4 animate-pulse"
              >
                <div className="w-10 h-10 bg-[#F2F4F7] rounded-lg flex-shrink-0"></div>
                <div className="flex-1 space-y-2 py-1">
                  <div className="h-4 bg-[#F2F4F7] rounded w-1/3"></div>
                  <div className="h-3 bg-[#F2F4F7] rounded w-3/4"></div>
                </div>
              </div>
            ))}
          </div>
        ) : items.length === 0 ? (
          <div className="flex flex-col items-center justify-center py-12 border border-dashed border-[#E8E8EA] rounded-xl bg-[#F9F9FC1A]">
            <CheckCircleOutlined className="text-3xl text-[#0ACD95] mb-3 opacity-60" />
            <p className="text-[var(--font-600)] font-medium">
              Everything looks good!
            </p>
            <p className="text-xs text-[var(--font-600)] opacity-70">
              Nothing needs attention right now.
            </p>
          </div>
        ) : (
          items.map((item) => (
            <div
              key={item.id}
              className="group border align-center border-[var(--surface-border)] rounded-xl px-4 py-[12px] flex items-start gap-4 cursor-pointer hover:border-[var(--accent-2)] hover:bg-[var(--surface-muted)] transition-all duration-200"
              onClick={() => handleAlertClick(item)}
            >
              <div
                className={`mt-0.5 w-[36px] h-[36px] rounded-lg flex items-center justify-center flex-shrink-0 text-xl ${
                  item.severity === 'high'
                    ? 'bg-[#FFF1F0]'
                    : item.severity === 'medium'
                    ? 'bg-[#FFF7EC]'
                    : 'bg-[#F0F9FF]'
                }`}
              >
                {getAlertIcon(item.type, item.severity)}
              </div>

              <div className="flex-1 min-w-0">
                <div className="flex items-center justify-between gap-2 mb-0.5">
                  <p className="font14px-600 text-[var(--textBlack)] truncate group-hover:text-[var(--accent-2)] transition-colors">
                    {item.title}
                    {item.severity && (
                  <span
                    className={`inline-flex items-center gap-1 text-[10px]   ml-2 font-semibold px-2 py-1 rounded-full ${
                      item.severity === 'high'
                        ? 'bg-[#FFF1F0] text-[#F96056]'
                        : item.severity === 'medium'
                        ? 'bg-[#FFF7EC] text-[#F6A723]'
                        : 'bg-[#F0F9FF] text-[#0B82F1]'
                    }`}
                  >
                    {item.severity.toUpperCase()}
                  </span>
                )}
                  </p>
                  <span className="text-[10px] text-[var(--font-600)] whitespace-nowrap opacity-60">
                    {item.created_at
                      ? new Date(item.created_at).toLocaleDateString()
                      : ''}
                  </span>
                </div>
                <p className="text-sm text-[var(--font-600)] line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NeedsAttentionCard;
